// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-frame-i1oSY4{width:24px;height:24px}.btn-frame-i1oSY4 .icon-j8XggS{color:#6b6b75}.btn-frame-i1oSY4.btn-frame-disabled-FVEwuy .icon-j8XggS{color:rgba(29,28,35,.2)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn-frame": `btn-frame-i1oSY4`,
	"btnFrame": `btn-frame-i1oSY4`,
	"icon": `icon-j8XggS`,
	"btn-frame-disabled": `btn-frame-disabled-FVEwuy`,
	"btnFrameDisabled": `btn-frame-disabled-FVEwuy`
};
export default ___CSS_LOADER_EXPORT___;
